import React from "react";

function Explainer() {
  return (
    <div className="brand-bg1">
      <div className="container text-center mb-5 mb-lg-10 py-10 py-lg-20">
        <p className="text-white lh-base fw-bolder mb-12">
          At 3rdRetail we use technology to bring to life distribution chain of
          products in Africa. A world of limitless opportunities
          <br />
          for Manufacturers, Brand Owners and Distributors
        </p>

        <a href="/Pagenotfound.html" className="btn btn-secondary">
          Get Started
        </a>
      </div>
    </div>
  );
}

export default Explainer;
